import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
// import moment from 'moment';
import { format, isValid, parse } from 'date-fns';


import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/WorkOff';
import Warning from '@material-ui/icons/Warning';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';

import { fetchEmployees, deleteEmployee, dissmissEmployee, cancelDismiss } from '../../store/actions/employee';
import { fetchBankOfHours } from '../../store/actions/bankOfHours';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import DataTable from '../../components/DataTable/DataTable';
import axiosInstance from '../../config/axiosInstance';
import Input from '../../components/Input/Input';
import { ModalFirstEmployee } from '../Employee/components/ModalFirstEmployee';

const styles = theme => ({
  input: {
    width: '40%',
    margin: theme.spacing(3),
  },
});

class Employees extends React.Component {
  state = {
    openModal: false,
    openConfirm: false,
    currentItem: null,
    searchQuery: '',
    startDate: null,
    endDate: null,
    lisEmployees: []
  };

  componentDidMount() {
    // this.props.onFetchEmployees();
    this.getListEmployees();
  }

  getListEmployees = async () => {
    const result = await axiosInstance.get('/employee/list')
    this.setState({ lisEmployees: result.data })
  }

  minuteToHour = (m) => {
    if (typeof m === 'string' && m.length >= 2) {
      return m;
    }

    const signal = m < 0 ? '-' : (this.props.positive ? '+' : '');

    if (m < 0) {
      m *= -1;
    }

    if (m !== 0) {
      const hours = Math.floor(m / 60);
      let minutes = m % 60;

      if (minutes < 9) {
        minutes = `0${minutes}`;
      }

      return `${signal + hours}h ${minutes}m`;
    }
    return '00:00';
  }

  handleFireClick = (item) => {
    if (item._optBankHours) {
      this.props.onFetchBankOfHours(item.id)
        .then((response) => {
          item.bankTotal = this.minuteToHour(response.global.balanceToBankHours);

          this.handleState(item);
        });
    } else {
      this.handleState(item);
    }
  };

  handleState = (item) => {
    this.setState({
      startDate: '',
      endDate: '',
    }, () => {
      let state = { openModal: true, currentItem: item };

      if (item.dtDemission && item.dtDemission.length) {
        state = {
          ...state,
          startDate: parse(item.dtDemission, 'yyyy-MM-dd', new Date()),
          endDate: parse(item.dtLastDayWork, 'yyyy-MM-dd', new Date()),
        };
      }
      this.setState(state);
    });
  }

  handleInputChange = name => (event) => {
    // this.setState({ [name]: event.target.value });
    if (event && event.target) {
      this.setState({ [name]: event.target.value });
    } else {
      this.setState({ [name]: event });
    }
  };

  handleDeleteCancel = () => {
    this.setState({ openModal: false, currentItem: null });
  };

  handleDeleteConfirm = () => {
    // this.props.onDeleteEmployee(this.state.currentItem.id);
    this.cleanResignation();
  };

  openConfirm = () => {
    this.setState({
      openModal: false,
      openConfirm: true,
    });
  }

  cleanResignation = () => {
    this.setState({
      openModal: false,
      openConfirm: false,
      currentItem: null,
      startDate: '',
      endDate: '',
    });
  }

  confirmDismiss = () => {
    if (this.state.currentItem.isFired) {
      this.props.onCancelDismiss(this.state.currentItem.id)
        .then(() => {
          this.getListEmployees();
          this.closeConfirm();
        })
        .catch(() => {
          this.closeConfirm();
        });
    } else {
      const employee = {
        employeeId: this.state.currentItem.id,
        dtDemission: this.state.startDate,
        dtLastDayWork: this.state.endDate,
      };

      this.props.onDissmissEmployee(employee)
        .then(() => {
          this.getListEmployees();
          this.closeConfirm();
        })
        .catch(() => {
          this.closeConfirm();
        });
    }
  }

  closeConfirm = () => {
    this.setState({
      openConfirm: false,
    });
  }

  render() {
    const {
      classes, employees, loading, history,
    } = this.props;

    const { searchQuery, startDate, endDate, lisEmployees } = this.state;

    const columns = [
      { name: 'name', label: 'Nome' },
      { name: 'cpfFormatted', label: 'CPF' },
      { name: 'phone', label: 'Telefone' },
      { name: 'department', label: 'Departamento' },
    ];

    const searchFields = ['name', 'cpf', 'department', 'phone'];

    const actions = [
      {
        name: 'Editar',
        icon: EditIcon,
        onClick: item => history.push(`/funcionarios/${item.id}`),
      },
      {
        name: 'Desligar', icon: DeleteIcon,
        iconColor: { condition: 'isFired', color: '#ffcc33' },
        onClick: item => (this.handleFireClick(item)),
      },
    ];

    const cpfFormatter = (string) => {
      if (string && string.length === 11) {
        return string.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }

      return string;
    };

    const filteredRows = lisEmployees.filter((employee) => {
      let hasField = false;
      searchFields.forEach((searchField) => {
        hasField = hasField || employee[searchField].includes(searchQuery.toUpperCase());
      });
      return hasField;
    }).map((item) => {
      const employee = { ...item };
      employee.cpfFormatted = cpfFormatter(employee.cpf);
      return employee;
    });

    const employeeAlphabetical = filteredRows.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    const isFired = this.state.currentItem && this.state.currentItem.isFired;

    return (
      <React.Fragment>
        <ContentHeader
          title="Listagem de Funcionários"
          subtitle="Listagem com os funcionários cadastrados na empresa"
        >
          <Button component={Link} to="/funcionarios/cadastrar" variant="contained" color="primary">
            <AddIcon /> ADICIONAR
          </Button>
        </ContentHeader>

        <Paper elevation={2}>

          <TextField
            className={classes.input}
            value={searchQuery}
            onChange={this.handleInputChange('searchQuery')}
            placeholder="Buscar"
            type="text"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="disabled" />
                </InputAdornment>
              ),
            }}
          />

          <DataTable
            rows={employeeAlphabetical}
            columns={columns}
            loading={loading}
            actions={actions}
          />
        </Paper>

        <ModalFirstEmployee />

        <Dialog open={this.state.openModal} onClose={this.cleanResignation}>
          <DialogTitle>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              Desligamento de {this.state.currentItem ? this.state.currentItem.name : ''}
              {
                this.state.currentItem && this.state.currentItem._optBankHours ?
                  <Tooltip
                    style={{ color: '#e00000', fontSize: '20px', marginLeft: '6px' }}
                    classes={{ tooltip: classes.lightTooltip }}
                    title={`Este funcionário possui ${this.state.currentItem.bankTotal} no banco de horas`}
                    aria-label="desligamento"
                    placement="top"
                  >
                    <Warning />
                  </Tooltip> :
                  null
              }
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>O funcionário não poderá realizar marcações de ponto e nem acessar suas informações após o último dia de trabalho.</DialogContentText>
            <div style={{ display: 'flex' }}>
              <Input
                elementType="datePicker"
                style={{ marginRight: '40px' }}
                label="Data da demissão"
                margin="normal"
                value={startDate || null}
                onChange={this.handleInputChange('startDate')}
                disabled={this.state.currentItem && this.state.currentItem.isFired}
              />

              <div style={{ marginLeft: 'auto' }}>
                <Input
                  elementType="datePicker"
                  label="Último dia de trabalho"
                  margin="normal"
                  value={endDate || null}
                  minDate={startDate}
                  minDateMessage="Não pode ser anterior à data da demissão"
                  onChange={this.handleInputChange('endDate')}
                  disabled={this.state.currentItem && this.state.currentItem.isFired}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button style={{ margin: 'auto' }} disabled={!isValid(startDate) || !isValid(endDate)} onClick={this.openConfirm} variant="contained" color="primary" autoFocus>
              {this.state.currentItem && this.state.currentItem.isFired ? 'CANCELAR DESLIGAMENTO' : 'DESLIGAR'}
            </Button>
          </DialogActions>
        </Dialog>

        {
          this.state.openConfirm && (
            <Dialog open={this.state.openConfirm} onClose={this.cleanResignation}>
              <DialogTitle>{isFired ? 'Cancelar' : 'Confirmar'} Desligamento de {this.state.currentItem ? this.state.currentItem.name : ''}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {
                    isFired ?
                      'Deseja cancelar o desligamento previsto para as seguintes datas:' :
                      'Deseja confirmar o desligamento nas seguintes datas:'
                  }
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <span>demissão - {format(startDate, 'dd/MM/yyyy')}</span>
                    <span style={{ marginLeft: '40px' }}>último dia - {format(endDate, 'dd/MM/yyyy')}</span>
                  </div>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.cleanResignation}>CANCELAR</Button>
                <Button onClick={this.confirmDismiss} variant="contained" color="primary" autoFocus>
                  CONFIRMAR
                </Button>
              </DialogActions>
            </Dialog>
          )
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  // employees: state.employee.employees,
  bankOfHours: state.bankOfHours.bankOfHours,
});

const mapDispatchToProps = dispatch => ({
  // onFetchEmployees: () => dispatch(fetchEmployees()),
  onDeleteEmployee: id => dispatch(deleteEmployee(id)),
  onDissmissEmployee: data => dispatch(dissmissEmployee(data)),
  onCancelDismiss: id => dispatch(cancelDismiss(id)),
  onFetchBankOfHours: id => dispatch(fetchBankOfHours(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Employees));
